import { Box, Typography } from "@material-ui/core";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { getDefaultCondicaoPagamentoId } from "../utils/paymentConditionUtils";

/** Dropdown de condição de pagamento reutilizado na grade (simulação) e no carrinho (real, por vitrine). */
export default function PaymentConditionSelect({
  condicoes,
  value,
  onChange,
  defaultId,
  theme,
  open,
  setOpen,
}) {
  if (!condicoes?.length) return null;

  const resolvedId =
    value ??
    getDefaultCondicaoPagamentoId(condicoes, defaultId) ??
    condicoes[0]?.idCondicaoPagamento;
  const selected = condicoes.find((c) => c.idCondicaoPagamento === resolvedId);
  const label = selected?.label || "Condição de pagamento";

  if (condicoes.length === 1) {
    return (
      <Box className="custom-select-wrapper" style={{ minWidth: 200, flex: 1 }}>
        <Box
          className="custom-select-btn"
          style={{ cursor: "default", pointerEvents: "none" }}
        >
          <Typography noWrap style={{ fontSize: 14, flex: 1 }}>
            {condicoes[0].label}
          </Typography>
        </Box>
      </Box>
    );
  }

  return (
    <Box className="custom-select-wrapper" style={{ minWidth: 220, flex: 1 }}>
      <Box
        className="custom-select-btn"
        onClick={() => setOpen(!open)}
        style={{
          borderColor: open ? theme.primary : undefined,
          boxShadow: open ? `0 0 0 1px ${theme.primary}` : undefined,
        }}
      >
        <Typography noWrap style={{ fontSize: 14, flex: 1, marginRight: 8 }}>
          {label}
        </Typography>
        <ExpandMoreIcon />
      </Box>
      {open && (
        <Box className="custom-select-list">
          {condicoes.map((condicao) => (
            <Box
              key={condicao.idCondicaoPagamento}
              className={`custom-select-item ${
                resolvedId === condicao.idCondicaoPagamento ? "selected" : ""
              }`}
              onClick={() => {
                onChange(condicao.idCondicaoPagamento);
                setOpen(false);
              }}
              style={
                resolvedId === condicao.idCondicaoPagamento
                  ? { backgroundColor: "#eff6ff", color: theme.primary }
                  : undefined
              }
            >
              <Typography style={{ fontSize: 13 }}>{condicao.label}</Typography>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
}
